import { BigNum, BN, FOUR, TWO, User, ZERO } from '@velocity-exchange/sdk';
import { getTotalIsolatedDepositsForUser } from 'src/stores/DriftStore/helpers/accountDataHelpers';
import { MarginInfo } from 'src/stores/driftStoreTypes';

/** Fields enriched by the caller from positions/orders data, or not computed here */
type EnrichedFields =
	| 'totalUnsettledPnl'
	| 'quoteInOpenOrders'
	| 'marketsNeedingSettlement';

export type BaseMarginInfo = Omit<MarginInfo, EnrichedFields>;

export function computeMarginInfo(user: User): BaseMarginInfo {
	let userMarginRatio = user.getMarginRatio();
	if (userMarginRatio.eq(new BN(Number.MAX_SAFE_INTEGER)))
		userMarginRatio = ZERO;

	const collateral = user.getNetSpotMarketValue();
	const unrealisedPnL = user.getUnrealizedPNL(true, undefined, undefined);
	const totalIsolatedDeposits = getTotalIsolatedDepositsForUser(user);
	const netUsdValue = collateral
		.add(unrealisedPnL ?? ZERO)
		.add(totalIsolatedDeposits);
	const freeCollateral = user.getFreeCollateral();
	const maintenanceFreeCollateral = user.getFreeCollateral('Maintenance');
	const totalCollateral = user.getTotalCollateral();
	const totalMaintenanceCollateral = user.getTotalCollateral('Maintenance');
	const leverage = BigNum.from(user.getLeverage(), FOUR).toNum();
	const marginRatioPct = BigNum.from(userMarginRatio, TWO).toNum();
	const maintenanceReq = user.getMaintenanceMarginRequirement();
	const initialReq = user.getInitialMarginRequirement();

	return {
		netUsdValue,
		collateral,
		unrealisedPnL,
		totalCollateral,
		totalMaintenanceCollateral,
		freeCollateral,
		maintenanceFreeCollateral,
		leverage,
		marginRatioPct,
		maintenanceReq,
		initialReq,
	};
}
